import React from 'react';
import { Button } from './Button';
import { ToggleButtonOption } from '../../Types';

const ToggleSwitch = ({ options }: { options: ToggleButtonOption[] }) => {
    return (
        <div className="flex gap-1 bg-input-backgroundColor rounded-button-border-radius w-fit">
            {options.map((option: ToggleButtonOption, index: any) => (
                <React.Fragment key={index}>
                    {(option?.renderCondition ?? true) && (
                        <Button
                            onClick={option.function}
                            className={`rounded-button-border-radius leading-[25px] transition duration-300  focus:outline-none ${
                                option.active
                                    ? ' bg-primary text-layout-textColorOnPrimary hover:bg-primary '
                                    : 'bg-transparent text-layout-textcolor hover:bg-button-secondary-background-hover group-box:hover:bg-button-secondary-box-background-hover'
                            }`}
                        >
                            {option.label}
                        </Button>
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};

export default ToggleSwitch;
